import React, { useState, useEffect } from "react";
import Layout from "../../components/layout/Layout";
import { connect, useDispatch, useSelector } from "react-redux";
import { addMemberships } from "../../redux/action/Memberships";
import { ManageServiceList } from "../../redux/action/services";
import { Formik } from "formik";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ValidationStripeKey } from "../../utills/Validation";
import { Keys, upadateKey } from "../../redux/action/stripe";

const AddStripe = () => {
  const resetForms = () => {
    document.getElementById("myForm").reset();
  };
  /* memberList */
  const dispatch = useDispatch();
  const KeyList = useSelector((state) => state.Stripe.list.stripe);
  const Key = KeyList?.[0]?.key;
  const KeyID = KeyList?.[0]?._id;
  useEffect(() => {
    dispatch(Keys());
  }, [dispatch]);

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <Layout title="Add Stripe Key" page="addStripe">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row">
              <div className="col-xl-8 offset-xl-2">
                <div className="card card-flush h-lg-100">
                  <div className="card-header pt-7">
                    <div className="card-title">
                      <span className="svg-icon svg-icon-1 me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                            fill="black"
                          ></path>
                          <path
                            opacity="0.3"
                            d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                            fill="black"
                          ></path>
                        </svg>
                      </span>
                      <h2>Add Stripe Key</h2>
                    </div>
                  </div>
                  <div className="card-body pt-5">
                    <Formik
                      initialValues={{
                        key: "",
                      }}
                      validationSchema={ValidationStripeKey}
                      onSubmit={(values) => {
                        dispatch(upadateKey(values, KeyID));
                        resetForms();
                      }}
                    >
                      {({
                        values,
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        errors,
                        touched,
                      }) => (
                        <form className="form" id="myForm">
                          <div className="mb-5">
                            <b>Current Stripe Key :</b> {Key}
                          </div>
                          <div className="row mb-8">
                            <div className="col-xl-2">
                              <div className="fs-6 fw-bold mt-2 mb-3"><span className="required">Key</span></div>
                            </div>
                            <div className="col-xl-10 fv-row fv-plugins-icon-container">
                              <input
                                type="text"
                                className="form-control form-control-solid"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="key"
                                id="key"
                                defaultValue={values.key}
                              />
                              {errors.key && touched.key ? (
                                <div className="text-danger mt-2">
                                  {errors.key}
                                </div>
                              ) : null}
                            </div>
                          </div>

                          <div className="separator mb-6"></div>
                          <div className="d-flex justify-content-end">
                            <Link
                              to="/add-stripe"
                              type="reset"
                              className="btn btn-light me-3"
                            >
                              Cancel
                            </Link>
                            <button
                              type="submit"
                              onClick={handleSubmit}
                              className="btn btn-primary"
                            >
                              <span className="indicator-label">Save</span>
                            </button>
                          </div>
                          <div></div>
                        </form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};
export default connect(null, { addMemberships, ManageServiceList })(AddStripe);
